export const AddToPlaylistIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='38'
    height='53'
    viewBox='0 0 38 53'
    fill='none'
  >
    <path d='M3.91309 11.1136H37.5V44.7006H3.91309V11.1136Z' stroke='white' />
    <path d='M1 10.6133V48.0155H38' stroke='white' />
    <path
      d='M7.73529 27.7734H18.6806V16.8281H20.79V27.7734H31.7353V29.8828H20.79V40.875H18.6806V29.8828H7.73529V27.7734Z'
      fill='white'
    />
  </svg>
);
